import { render, staticRenderFns } from "./menu-form.vue?vue&type=template&id=63b5d252&"
import script from "./menu-form.vue?vue&type=script&lang=js&"
export * from "./menu-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports